import React from 'react';

const inches = mm => Number.isFinite(mm) ? `${(mm / 25.4).toFixed(1)} in` : 'Unavailable';

export default function BenchmarkResults({ report }) {
  if (!report?.stations.length) return null;
  return <section className="rekkie-snow-stations" aria-label="Historical benchmark">
    <div className="rekkie-snow-detail-heading"><h3>Historical benchmark</h3><span className="rekkie-snow-status">Exploratory · Station only</span></div>
    <p>{report.config.from} through {report.config.through} · {report.config.issueLocalHour}:00 local issues · {report.config.assumedLatencyHours} h assumed source delay</p>
    {report.stations.map(station => <div key={station.id}>
      <h4>{station.name}</h4>
      <p>{station.summary.scored} / {station.summary.requested} days scored · {station.summary.excluded} excluded · {station.summary.failed} source or extraction failures</p>
      <div className="rekkie-snow-table-wrap"><table>
        <thead><tr><th>Observed conditions</th><th>Days</th><th>HRRR mean absolute error</th><th>HRRR mean bias</th><th>Always-zero forecast error</th></tr></thead>
        <tbody>{[['All days', 'allDays'], ['Snow days', 'snowDays'], ['Dry days', 'dryDays']].map(([label, key]) => {
          const metrics = station.summary[key];
          return <tr key={key}><th scope="row">{label}</th><td>{metrics.count}</td><td>{inches(metrics.maeMm)}</td><td>{inches(metrics.biasMm)}</td><td>{inches(metrics.zeroSnowMaeMm)}</td></tr>;
        })}</tbody>
      </table></div>
      <p>Every calendar day stays in the coverage count. Trace amounts are excluded from numeric scores. Historical availability and resort accuracy remain unverified.</p>
      <details><summary>Daily results and exclusions</summary>
        <div className="rekkie-snow-table-wrap"><table>
          <thead><tr><th>Observation date</th><th>Window</th><th>HRRR</th><th>Measured</th><th>Error / exclusion</th></tr></thead>
          <tbody>{report.cases.filter(row => row.stationId === station.id).map(row => <tr key={row.caseId}>
            <th scope="row">{row.date}</th>
            <td title={row.targetFrom && `${row.targetFrom} to ${row.targetUntil}`}>{row.targetFrom ? `${(Date.parse(row.targetUntil) - Date.parse(row.targetFrom)) / 3600000} h` : 'Unavailable'}</td>
            <td>{row.status === 'scored' ? inches(row.forecastMm) : 'Unavailable'}</td>
            <td>{row.status === 'scored' ? inches(row.observedMm) : 'Unavailable'}</td>
            <td>{row.status === 'scored' ? inches(row.errorMm) : `${row.status}: ${row.reason}`}</td>
          </tr>)}</tbody>
        </table></div>
      </details>
      <a href={station.observationSource.url} target="_blank" rel="noreferrer">NOAA station records ↗</a>
    </div>)}
    <details><summary>Benchmark provenance</summary>
      <p>Run {report.id}</p><p>Generated {report.generatedAt}</p>
      <p>{report.config.purpose}</p>
      <p>Source files, predictions, observation references and code hashes are retained with this run. No fitted correction or trained model is included.</p>
    </details>
  </section>;
}
